import React from "react";
import { Context } from "../../context";
import { DetailsViews } from "../../api/views";
import { Dates } from "./dates";
import { Progress } from "./progress";
import { Props } from "./types";

function Details(props: Props) {
  const { detailsView } = React.useContext(Context);

  return detailsView === DetailsViews.PROGRESS ? (
    <Progress {...props} />
  ) : (
    <Dates {...props} />
  );
}

export { Details };
